/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import * as client from 'DesignData/api/DefaultModules';
import { SUCCEEDED, PENDING } from 'DesignData/enums/RequestStatus';
import { FINDER_FILEMAPPER_FETCH_DEFAULT } from 'DesignData/actions/ActionTypes';
import { getDefaultsFetchStatus } from 'DesignData/selectors/finder';
import { getFileAndFolderDataFromFileMapperTree } from 'DesignData/helpers/finderHelpers';
let reqFetchDefault = Promise.resolve();
/**
 * Fetch `@hubspot` tree
 */

export function fetchDefault() {
  const type = FINDER_FILEMAPPER_FETCH_DEFAULT;
  return (dispatch, getState) => {
    switch (getDefaultsFetchStatus(getState())) {
      case SUCCEEDED:
      case PENDING:
        return reqFetchDefault;

      default:
        break;
    }

    const request = () => dispatch({
      type
    });

    const receive = tree => {
      const contents = getFileAndFolderDataFromFileMapperTree(tree);
      dispatch({
        type,
        tree,
        contents
      });
    };

    const error = err => dispatch({
      type,
      error: err
    });

    request();
    reqFetchDefault = client.fetchDefaultModules();
    reqFetchDefault.then(receive);
    reqFetchDefault.catch(error);
    return reqFetchDefault;
  };
}